import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {logoutProvider, logoutUser, patientTempLogin} from "../../store/actions/account.action";
import {StateParams} from "../../store/reducers";
import {MixpanelContext} from "../../analytics/Mixpanel";
import {clearAllData, setAppointmentId} from "../../store/actions/signup.action";

const SMS_LOGIN_SOURCE = "sms-temp-link"
const PatientScreeningEntryScreen = () => {
    const analytics = React.useContext(MixpanelContext);
    const {
        patientId,
        practiceId,
    } = useParams();
    const [searchParams] = useSearchParams()
    const {
        jwt,
        signInError,
    } = useSelector((state: StateParams) => state.account);
    const [readyForScreening, setReadyForScreening] = useState<boolean>(false);
    const [invalidLink, setInvalidLink] = useState<boolean>(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        setReadyForScreening(false)
        localStorage.removeItem("sj:patient-session-id")
        Object.keys(sessionStorage).filter(k => k.startsWith('pf_')).forEach(k => sessionStorage.removeItem(k))
        console.log("PSES: LOGOUT USER")
        dispatch(logoutUser())
        console.log("PSES: LOGOUT PROVIDER")
        dispatch(logoutProvider())
        console.log("PSES: CLEAR ALL DATA")
        dispatch(clearAllData())
    }, []);

    useEffect(() => {
        const appointmentId = searchParams.get('appointmentId')
        const screenerSentById = searchParams.get('screenerSentById')
        const loginSource = searchParams.get('loginSource')
        if (practiceId && patientId) {
            const loginPayload: Parameters<typeof patientTempLogin>[0] = {
                practiceId,
                patientId,
                loginSource: loginSource || SMS_LOGIN_SOURCE
            };
            if (appointmentId) {
                loginPayload.appointmentId = appointmentId;
            }
            if (screenerSentById) {
                loginPayload.screenerSentById = screenerSentById;
            }
            console.log("dispatching patientTempLogin with payload", loginPayload)
            dispatch(patientTempLogin(loginPayload));
            if(appointmentId) {
                console.log("setting appointmentId from query params")
                dispatch(setAppointmentId({ appointmentId }))
            }
            setReadyForScreening(true);
        } else {
            setInvalidLink(true);
        }
    }, [practiceId, patientId]);

    useEffect( () => {
        if (jwt && readyForScreening && !invalidLink) {
            console.log("sending mixpanel analytics for opened_screener_link_via_sms");

            // Wrap Mixpanel track event in a Promise with a fallback timeout
            const trackEvent = new Promise((resolve) => {
                analytics?.identify(patientId);
                analytics?.track("opened_screener_link_via_sms", { practiceId, patientId }, resolve);
            });

            const timeout = new Promise((resolve) =>
                setTimeout(() => {
                    console.warn("Mixpanel tracking timed out; proceeding to /patientProfile.");
                    resolve(null);
                }, 500)
            );

            // Navigate to patient profile when either event tracking or timeout finishes
            Promise.race([trackEvent, timeout]).then(() => {
                navigate('/patientProfile');
            });
        }
    }, [jwt, invalidLink, readyForScreening, analytics, patientId, practiceId]);

    return (
        <div className={"static-full-screen"}>
            {
                (signInError || invalidLink) &&
                <h1>Screener Link is invalid, please contact your provider</h1>
            }
        </div>
    );
}

export default PatientScreeningEntryScreen;
